:host {
  font-family: var(--font-family);
  font-size: var(--font-size);
  line-height: normal;
}

a {
  display: flex;
  align-items: center;
  background: linear-gradient(45deg, #faa755, #fcca99);
  border-radius: 1em;
  position: fixed;
  bottom: 0.75em;
  right: 0.75em;
  box-shadow: rgba(0,0,0,0.3) 0px 2px 16px 0px;
  color: var(--color-penn-blue);
  text-decoration: none;
  font-weight: 500;
  padding: 0.15em;
  font-size: 1em;

  @media (min-width: 820px) {
    bottom: 1.5em;
    right: 1.5em;
    width: auto;
    padding: 0.15em 0.75em;
    padding-left: 0.5em;
  }
}

a:hover {
  text-decoration: underline;
  text-underline-offset: var(--link-text-underline-offset);
  text-decoration-thickness: var(--link-hover-text-decoration-thickness);
}

a:hover,
a:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-bg-attention),0 0 0 4px var(--color-penn-blue), rgba(0,0,0,0.3) 0px 2px 16px 0px;;
}

svg {
  width: 2.5em;
  height: 2.5em;
}

span {
  display: none;
  font-size: 1.1em;

  @media (min-width: 820px) {
    display: inline;
  }
}